// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__gwyJp","label":"Radio_label__1YW1S","checkMark":"Radio_checkMark__10aYN","disabled":"Radio_disabled__2rAvb"};